<div class="chart-container">
  <canvas #canvas></canvas>

  <section class="stacks-labels" *ngIf="stacksLabels.length">
    <p>{{ 'reports.barChart.stacksTitle.default.summary' | translate }} :</p>
    <ul>
      <li *ngFor="let label of stacksLabels"> {{label}}</li>
    </ul>
  </section>
</div>